import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA service worker (production only — avoid SW caching in dev reload loops).
// When a new worker takes control we hard-reload so users get the latest UI without
// having to manually clear cache.
if ("serviceWorker" in navigator && window.location.hostname !== "localhost") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      // Re-check for updates every time the app regains focus.
      window.addEventListener("focus", () => { try { reg.update(); } catch (_) { /* ignore */ } });
      reg.addEventListener("updatefound", () => {
        const newSW = reg.installing;
        if (!newSW) return;
        newSW.addEventListener("statechange", () => {
          if (newSW.state === "installed" && navigator.serviceWorker.controller) {
            // A new version is ready. Ask it to take over and reload once it does.
            newSW.postMessage({ type: "SKIP_WAITING" });
          }
        });
      });
      let reloading = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (reloading) return;
        reloading = true;
        window.location.reload();
      });
    }).catch(() => {
      /* silently ignore — app still works without offline support */
    });
  });
}
